import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";
import moment from "moment";
import Modal from "react-modal";
import { toast } from "react-toastify";
import SimpleMap from "../../../../components/gmaps";
const TobaccoProcessingForm = (props) => {
  const frmRef = useRef({});
  const [loading, setLoading] = useState(false);

  const productRef = useRef({});
  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);

  const [employeelist, setEmployeelist] = useState(null);
  const [assignEmployeeId, setAssignEmployeeId] = useState();

  const [productData, setProductData] = useState([]);
  const [productId, setProductId] = useState();

  const [availableAmount, setavailableAmount] = useState();
  const [unitId, setunitId] = useState();
  const [batchDetail, setBatchDetail] = useState([]);
  const [productBatch, setProductBatch] = useState([]);
  const [totalUsedQty, setTotalUsedQty] = useState(0);
  const [totalUsedCost, setTotalUsedCost] = useState(0);

  const [warehosuelatLong, setWarehosuelatLong] = useState({
    lat: "",
    lng:"",
  });

    useEffect(() => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
          //console.log(lat, long);
          setWarehosuelatLong({ lat, lng });
        },
        (error) => {
          console.error(error);
        }
      );
    }, []);
  const [warehosuelatLongstr, setwarehosuelatLongstr] = useState();

  const [latLongclose, setLatLongclose] = useState(false);

  const [warehosuedata, setWarehosuedata] = useState([]);
  const [warehouseId, setWarehouseId] = useState();

  const [issuingFor, setIssuingFor] = useState();
  const [decimalPattern, setDecimalPattern] = useState(
    localStorage.getItem("decimalPattern")
  );
  const [integerPattern, setIntegerPattern] = useState(
    localStorage.getItem("integerPattern")
  ); // ;

  const handleLatLong = () => {
    setLatLongclose(true);
  };

  var d = new Date();
  var dateString =
    d.getDate() +
    "/" +
    (d.getMonth() + 1) +
    "/" +
    d.getFullYear() +
    " " +
    d.getHours() +
    ":" +
    d.getMinutes() +
    ":" +
    d.getSeconds();

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const [estimatedDeliveryDate, setestimatedDeliveryDate] = useState(
    new Date().toISOString().substr(0, 10)
  );
  const currentDate = new Date().toISOString().slice(0, 10);

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  function getCurrentTime() {
    const now = new Date();
    let hours = now.getHours();
    let minutes = now.getMinutes();

    // Format hours and minutes with leading zeros if necessary
    hours = hours.toString().padStart(2, "0");
    minutes = minutes.toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  }

  const { sendRequest: postProcurementOfficer } = useHttp();

  const { sendRequest: getEmp } = useHttp();
  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        var empData = data.output.filter(
          (item) => item.empId != localStorage.getItem("empId")
        );
        setEmployeelist(empData);
      }
    );
  }, [getEmp]);

  const { sendRequest: getWarehouseData } = useHttp();

  const getWarehouseDetail = () => {
    getWarehouseData(
      {
        // url: "/api/warehouses/",
        url: `/api/warehouses/?orgId=${localStorage.getItem("orgId")}&&storeTypeId=1&&createdBy=${localStorage.getItem("id")}`,
      },
      (res) => {
        if (res) {
          //console.log(res);

          var warehouse = res;
          setWarehosuedata(warehouse);
        }
      }
    );
  };

  useEffect(() => {
    getWarehouseDetail();
  }, [getWarehouseData]);

  const { sendRequest: getproduct } = useHttp();

  const getProductDetail = () => {
    getproduct(
      {
        url: "/api/product/",
      },
      (res) => {
        if (res) {
          console.log("product", res);
          var productData = res.filter(
            (item) =>
              (item.productTypeName =
                "Finish Product" || item.productTypeName == "Raw Produce")
          );
          setProductData(productData);
        }
      }
    );
  };

  useEffect(() => {
    getProductDetail();
  }, [getproduct]);

  const { sendRequest: getAvailableStock } = useHttp();

  const loadStockData = (id) => {
    productRef.current.productSubType.value = "";
    productRef.current.productType.value = "";

    var itemlist = productData.filter((item) => item.productId == id);
    var selectedItem = itemlist[0];

    productRef.current.productSubType.value = selectedItem.productSubTypeName;
    productRef.current.productType.value = selectedItem.productTypeName;
    const data = {
      warehouseId: warehouseId,
      productId: id,
    };

    getAvailableStock(
      {
        url: "/api/getAvailableStock/",
        method: "POST",
        body: data,
      },
      (myres) => {

        var res=myres.data
        //console.log("getAvailableStock", res);
        productRef.current.availableQuantity.value = res.availableQty;
        productRef.current.productUnit.value = res.unitName;
        productRef.current.unitId.value = res.unitId;
        productRef.current.availableAmount.value = res.availableAmount;
        setavailableAmount(res.availableAmount);
        setunitId(res.unitId);
      }
    );
  };

  const { sendRequest: getStockBatchNowise } = useHttp();
  const FillStockBatchNowise = (_productId) => {
    if (_productId > 0) {
      //console.log("_productId", _productId);
      //console.log("batchDetail", batchDetail);

      var productData = batchDetail.filter(
        (item) => item.productId == _productId
      );
      //console.log("productData", productData);

      if (productData && productData.length == 0) {
        getStockBatchNowise(
          {
            url: `/api/getStockBatchNowise/?productId=${_productId}&&orgId=${localStorage.getItem(
              "orgId"
            )}&&warehouseId=${warehouseId}`,
          },
          (res) => {
            if (res) {
              //console.log(res);
              res.forEach((element) => {
                element["productUsedQuantity"] = "0";
              });
              setProductBatch(res);
              var totalqty = 0;
              var pBatch = res;

              // var i = 0;
              // var grossNetUnitId;
              // do {
              //   // grossNetUnitId = pallet[0].grossNetUnitId;
              //   var productItem = productDetails[i];

              //   if (productItem.productId == selectedProductId) {
              //     productDetails[i].deliveryDispatchQuantity =     frmRef.current.totalDispatchQuantity.value;
              //     productDetails[i].deliveryDispatchQuantityBalance =    frmRef.current.totalDispatchQuantity.value;
              //   }
              //   i++;
              // } while (productDetails.length > i);

              // pBatch.forEach(element => {
              //   totalqty=totalqty+parseFloat(element.productUsedQuantity==""?0:element.productUsedQuantity);
              // });
            }
          }
        );
      } else {
        var pBatch = productData;
        var totalqty = 0;
        pBatch.forEach((element) => {
          totalqty =
            totalqty +
            parseFloat(
              element.productUsedQuantity == ""
                ? 0
                : element.productUsedQuantity
            );
        });

        // frmRef.current.totalDispatchQuantity.value=totalqty;
        setTotalUsedQty(totalqty);
        setProductBatch(productData);
      }
    } else {
      setProductBatch([]);
    }
  };

  const handleBatchQuantityChange = (index, event) => {
    var val = parseFloat(event.target.value ?? "0");
    var amountval = 0;
    if (productBatch[index].productQuantityBal < val) {
      //console.log("val", val);
      val = 0;
      amountval = 0;
      event.target.value = 0;
    }

    productBatch[index].productUsedQuantity = val;

    console.log("productAmountBal", productBatch[index].productAmountBal);
    amountval =
      (parseFloat(productBatch[index].productAmountBal ?? 0) /
        parseFloat(productBatch[index].productQuantityBal ?? 0) ?? 0) *
      parseFloat(val ?? 0);
    console.log("amountval", amountval);

    productBatch[index].productUsedCost = amountval;

    // productBatch[index].productUsedCost = val;
    setProductBatch(productBatch);

    var totalqty = 0;
    var totalAmount = 0;
    var pBatch = productBatch;

    pBatch.forEach((element) => {
      totalqty =
        totalqty +
        parseFloat(
          element.productUsedQuantity == "" ? 0 : element.productUsedQuantity
        );
      totalAmount = totalAmount + parseFloat(element.productUsedCost ?? 0);
    });
    setTotalUsedQty(totalqty);
    setTotalUsedCost(totalAmount.toFixed(2));

    productRef.current.itemQuantity.value = totalqty;
    // frmRef.current.totalDispatchQuantity.value=totalqty;
  };

  const submitHandler = (e) => {
    e.preventDefault();
  
    var plist = [];
    if (batchDetail.length == 0) {
      toast.success("Please enter at least one product!");
      return;
    } else {
      console.log("batchDetail", batchDetail);
      plist = batchDetail.filter((e) => (e.productUsedQuantity ?? 0) > 0);
      console.log("plist", plist);
    }
    setLoading(false);
    
    const data = {
      tobaccoProcessingDate: moment(frmRef.current.date.value).format(
        "DD/MM/YYYY"
      ),
      issueTime: frmRef.current.time_stamp.value,
      productDetails: plist,
      issuingFor: "issuingFor",
      warehouseId: warehouseId,
      issueByEmployeeId: warehouseId,
      issueToEmployeeId: assignEmployeeId,
      remark: frmRef.current.remark.value,
      status: 1,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      serviceId: props.sId,
    };

    if (props.update) {
      data["gtProcurementId"] = props.update.gtProcurementId;
    }
    postProcurementOfficer(
      {
        url: "/api/tobaccoProcessing/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        //console.log(data);
        toast.success(
          `Goods issued for tobacco processing ${
            props.update ? "updated" : "added!"
          }`
        );
        setLoading(false);

        props.addForm(false);
      },
      (error) => {
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    if (props.update) {
      frmRef.current.date.value = moment(props.update.gtProcurementDate).format(
        "YYYY-MM-DD"
      );
      frmRef.current.emp_id.value = props.update.procurementOfficerEmpId;
      frmRef.current.time_stamp.value = moment(
        props.update.timeStamp,
        "HH:mm"
      ).format("hh:mm");
      setProductDetails(props.update.productDetails);
      frmRef.current.gate_pass_id.value = props.update.gatepassId;
      frmRef.current.vehicle_id.value = props.update.vehicleId;
      frmRef.current.driver_name.value = props.update.driverName;
      frmRef.current.driver_contact_number.value = props.update.driverContactNo;
      frmRef.current.start_meter_reading.value = props.update.startMeterReading;
      frmRef.current.end_meter_reading.value = props.update.endMeterReading;
      frmRef.current.remark.value = props.update.remark;
    }
  }, [props.update]);

  const submitProduct = (e) => {
    e.preventDefault();
    var itemlist = productData.filter((item) => item.productId == productId);
    var selectedItem = itemlist[0];

    var productId1 = productId;
    var itemId = selectedItem.itemId;
    var productName = selectedItem.productName;
    var productSubType = productRef.current.productSubType.value;
    var productType = productRef.current.productType.value;
    var availableQuantity = productRef.current.availableQuantity.value;
    var unit = productRef.current.productUnit.value;
    var unitId1 = unitId;
    var availableAmount1 = availableAmount;
    var itemQuantity = productRef.current.itemQuantity.value;

    var pdlist = productDetails.filter((item) => item.productId == productId1);

    if (parseFloat(itemQuantity ?? 0) <= 0) {
      toast.success("Please enter product quantity", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    if (pdlist.length != 0) {
      toast.success("Product already present into the list", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    setProductDetails((x) => [
      ...x,
      {
        srno:
          productDetails.length > 0
            ? productDetails[productDetails.length - 1].srno + 1
            : 1,
        productId: productId1,
        itemId: itemId,
        productName: productName,
        productSubType: productSubType,
        productType: productType,
        availableQuantity: availableQuantity,
        unit: unit,
        unitId: unitId1,
        availableAmount1: availableAmount1,
        itemQuantity: itemQuantity,
        itemQuantityBal: itemQuantity,
        productCost: 0,
        remark: frmRef.current.remark.value,
        status: 1,
        createdBy: parseInt(localStorage.getItem("id")),
        orgId: localStorage.getItem("orgId"),
        // itemType: productRef.current.itemType.value,
        // itemCategory: productRef.current.itemCategory.value,
        // itemQuantity: productRef.current.itemQuantity.value,
        // unit: productRef.current.unit.value,
        // itemUnitPrice: productRef.current.itemUnitPrice.value,
        // rate: productRef.current.rate.value,
        // currency: productRef.current.currency.value,
        // totalAmount: productRef.current.totalAmount.value,
      },
    ]);

    setProductId(0);

    productRef.current.productSubType.value = "";
    productRef.current.productType.value = "";
    productRef.current.availableQuantity.value = "";
    productRef.current.productUnit.value = "";
    setunitId(0);
    setavailableAmount(0);
    productRef.current.itemQuantity.value = "0";
    //console.log(productDetails);

    var prdarrray = [...batchDetail, ...productBatch];
    setBatchDetail(prdarrray);
    setProductBatch([]);
    setTotalUsedQty(0);
    setTotalUsedCost(0);
  };
  const handleDelete = (index, e) => {
    setProductDetails(productDetails.filter((v, i) => i !== index));
  };

  const handleValidateQuantityChange = (event) => {
    var validator = new RegExp("^[0-9.]*$");

    var qtyvalid = validator.test(event.target.value);
    //console.log("handleValidateQuantityChange");
    //console.log(qtyvalid);
    if (qtyvalid) {
      var quantity = parseFloat(event.target.value);

      var totalquantity = parseFloat(
        productRef.current.availableQuantity.value
      );

      if (quantity > totalquantity) {
        event.target.value = 0;
        toast.success("Please enter quanitty less than total quantity", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } else {
      event.target.value = 0;
    }
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
      left: 40,
    },
    content: {
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "900px",
      minHeight: "500px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const scrollstyle = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
      left: 40,
    },
    content: {
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "700px",
      minHeight: "200px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };
  return (
    <>
      <Modal isOpen={close} style={customModalStyles}>
        <div>
          <div>
            <div className="">
              <div className="">
                <h3 className="card-title">Product Details</h3>
                <div className="card-tools text-right">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => setClose(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                  <hr />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-3">
                {" "}
                <label htmlFor={"productId"}> Product Name </label>
                <select
                  id="productId"
                  className="form-control"
                  ref={(el) => (frmRef.current["productId"] = el)}
                  value={productId}
                  onChange={(e) => {
                    setProductId(e.target.value);

                    loadStockData(e.target.value);
                    FillStockBatchNowise(e.target.value);
                  }}
                >
                  <option>--Select Product Name--</option>
                  {productData &&
                    productData.map((x) => (
                      <option
                        key={x.productId}
                        product-id={x.productId}
                        value={x.productId}
                      >
                        {x.productName + "(" + x.itemId + ")"}
                      </option>
                    ))}
                </select>
              </div>
              <div className="col-md-3">
                {" "}
                <label htmlFor={"productId"}> Product SubType </label>{" "}
                <input
                  type={"input"}
                  id={"itemType"}
                  readOnly
                  ref={(el) => (productRef.current["productSubType"] = el)}
                  className="form-control"
                />{" "}
              </div>
              <div className="col-md-3">
                <label htmlFor={"productId"}> Product Type </label>{" "}
                <input
                  type={"input"}
                  id={"productType"}
                  readOnly
                  ref={(el) => (productRef.current["productType"] = el)}
                  className="form-control"
                />{" "}
              </div>
            </div>

            <div className="row">
              <div className="col-md-3">
                {" "}
                <label htmlFor={"Available"}>Total Available Quantity</label>
                <input
                  type={"input"}
                  id={"itemType"}
                  readOnly
                  ref={(el) => (productRef.current["availableQuantity"] = el)}
                  className="form-control"
                />
              </div>
              <div className="col-md-3">
                {" "}
                <label htmlFor={"unit"}> Unit</label>
                <input
                  type={"input"}
                  id={"itemType"}
                  readOnly
                  ref={(el) => (productRef.current["productUnit"] = el)}
                  className="form-control"
                />
                <input
                  name="hiddenInput"
                  value=""
                  type="hidden"
                  ref={(el) => (productRef.current["unitId"] = el)}
                />
                <input
                  name="hiddenInput"
                  value=""
                  type="hidden"
                  ref={(el) => (productRef.current["availableAmount"] = el)}
                />
              </div>
              <div className="col-md-3"></div>

              <div className="col-md-3"></div>
            </div>

            <div className="row">
              <table className="table table-bordered text-center">
                <thead>
                  <tr>
                    <th>Product Name</th>
                    <th>Batch No </th>
                    <th>Bales No </th>
                    <th>Tag Serial No </th>
                    <th>Available Quantity</th>
                    <th>Unit</th>
                    <th>Quantity</th>
                    <th>Unit</th>
                  </tr>
                </thead>
                <tbody>
                  {productBatch &&
                    productBatch.map((itm, i) => {
                      return (
                        <tr key={i}>
                          <td>{itm.productName}</td>
                          <td>{itm.batchNo}</td>
                          <td>{itm.balesNo}</td>
                          <td>{itm.sellingTagSerialNo}</td>
                          <td>{itm.productQuantityBal}</td>
                          <td>{itm.unitAbbreviation}</td>

                          <td>
                            <input
                              type={"text"}
                              id={"itemQuantity"}
                              defaultValue={itm.productUsedQuantity}
                              required
                              ref={(el) =>
                                (frmRef.current["productUsedQuantity"] = el)
                              }
                              className="inputs"
                              onChange={(e) => {
                                handleBatchQuantityChange(i, e);
                              }}
                            />
                          </td>

                          <td>{itm.unitAbbreviation}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>{" "}
            </div>

            <div className="row">
              <div className="col-md-3"> </div>
              <div className="col-md-3"> </div>
              <div className="col-md-3">
                <label htmlFor={"unit"}> Item Quantity</label>
                <input
                  type={"input"}
                  id={"itemType"}
                  pattern={decimalPattern}
                  readOnly
                  onChange={(e) => {
                    handleValidateQuantityChange(e);
                  }}
                  ref={(el) => (productRef.current["itemQuantity"] = el)}
                  className="form-control"
                />
              </div>

              <div className="col-md-3">
                <br />{" "}
                <button
                  className="btn  btn-success mx-2 my-2"
                  onClick={submitProduct}
                >
                  +
                </button>{" "}
              </div>
            </div>
            <hr />

            <div className="row">
              <table className="table table-bordered text-center">
                <thead>
                  <tr className="tableheaderrowview">
                    <th>Sr. No</th>
                    <th>Item Id</th>
                    <th>Product Name</th>

                    <th>Item SubType</th>
                    <th>Item Type</th>
                    <th>Available Quantity</th>
                    <th>Unit</th>
                    <th>Item Quantity</th>
                    <th>Unit</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {productDetails &&
                    productDetails.map((itm, i) => {
                      return (
                        <tr key={i.srno}>
                          <td>{itm.srno}</td>
                          <td>{itm.itemId}</td>
                          <td>{itm.productName}</td>
                          <td>{itm.productSubType}</td>
                          <td>{itm.productType}</td>
                          <td>{itm.availableQuantity}</td>
                          <td>{itm.unit}</td>
                          <td>{itm.itemQuantity}</td>
                          <td>{itm.unit}</td>
                          {/* <td>{itm.totalAmount}</td> */}
                          <td>
                            {" "}
                            <button
                              className="btn"
                              onClick={(e) => handleDelete(i, e)}
                            >
                              <i className="fas fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>

            <div className="row">
              <div className="col-md-3"></div>
              <div className="col-md-2"></div>

              <div className="col-md-2">
                <button
                  className="btn  btn-primary mx-2 my-2"
                  onClick={() => {
                    productDetails.map((x) => (x["isSave"] = true));
                    setClose(false);
                  }}
                >
                  Save
                </button>
              </div>
              <div className="col-md-3"></div>
            </div>
          </div>
        </div>
      </Modal>

      {latLongclose && (
        <Modal onClose={setLatLongclose}>
          <SimpleMap
            lat={warehosuelatLong.lat}
            lng={warehosuelatLong.lng}
            set={setWarehosuelatLong}
            close={setLatLongclose}
          />
        </Modal>
      )}

      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Add Tobacco Processing Detail</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-2">
                      <label htmlFor={"date"}>{"Date "}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>

                    <div className="col-md-2">
                      <label htmlFor={"time_stamp"}>{"TimeStamp"}</label>
                      <input
                        type={"time"}
                        id={"time_stamp"}
                        required
                        ref={(el) => (frmRef.current["time_stamp"] = el)}
                        className="form-control"
                        defaultValue={getCurrentTime()}
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"emp_id"}>{"Trasnfer To Employee"}</label>
                      <select
                        id="emp_id"
                        required
                        className="form-control"
                        ref={(el) => (frmRef.current["assignEmployeeId"] = el)}
                        value={assignEmployeeId}
                        onChange={(e) => {
                          setAssignEmployeeId(e.target.value);
                        }}
                      >
                        <option selected disabled value="">
                          --Select Employee--
                        </option>
                        {employeelist &&
                          employeelist.map((x) => (
                            <option
                              key={x.empId}
                              employee-id={x.empId}
                              value={x.empId}
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"warehouseId"}>{"Warehosue"}</label>

                      <select
                        id="warehouseId"
                        className="form-control"
                        ref={(el) => (frmRef.current["warehouseId"] = el)}
                        value={warehouseId}
                        required
                        onChange={(e) => {
                          setWarehouseId(e.target.value);
                        }}
                      >
                        <option selected disabled value="">
                          --Select Warehouse--
                        </option>
                        {warehosuedata &&
                          warehosuedata.map((x) => (
                            <option key={x.id} warehouse-id={x.id} value={x.id}>
                              {x.name} {}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>

                  <div className="row">&nbsp;</div>
                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"issuingFor"}>{"Issuing For"}</label>

                      <select
                        id="warehouseId"
                        className="form-control"
                        ref={(el) => (frmRef.current["issuingFor"] = el)}
                        value={issuingFor}
                        required
                        onChange={(e) => {
                          setIssuingFor(e.target.value);
                        }}
                      >
                        <option selected value="">
                          --Select Issuing For--
                        </option>
                        <option>Hand Stripping</option>
                        <option>Processing</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label> {"Product Details"}</label>
                      <br />
                      <button
                        className="btn btn-sm  btn-success mx-2 my-2"
                        formNoValidate="True"
                        onClick={(e) => {
                          e.preventDefault(false);
                          productDetails &&
                            setProductDetails((items) =>
                              items.filter((x) => x.isSave)
                            );
                          setClose(true);
                        }}
                      >
                        Add
                      </button>
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Submit"}
                      </button>
                    </div>
                    <div className="col-md-1">
            
                    </div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default TobaccoProcessingForm;
